import type { Cookie, CookieSetOptions } from 'universal-cookie';
import Cookies from 'universal-cookie';

import { ACCOUNT_IDENTITY } from '@/_config';
import { logger } from '@/_shared/utils';

const cookies = new Cookies();

export const getCookie = (key: string) => {
  return cookies.get(key);
};

export const setCookie = (key: string, value: Cookie, options: CookieSetOptions = { path: '/' }) => {
  cookies.set(key, value, options);
};

export const removeCookie = (key: string, options: CookieSetOptions = { path: '/' }) => {
  return cookies.remove(key, options);
};

export const setAuthTokens = (
  access: string,
  refresh: string,
  type = ACCOUNT_IDENTITY.STUDENT,
  options: CookieSetOptions = { path: '/' }
) => {
  setCookie('refresh', refresh, options);
  setCookie('access', access, options);
  setCookie('type', type ?? ACCOUNT_IDENTITY.STUDENT, options);
};

export const removeAuthTokens = (options: CookieSetOptions = { path: '/' }) => {
  logger.clearSession();
  removeCookie('access', options);
  removeCookie('refresh', options);
  removeCookie('type', options);
  logger.clearSession();
};

export const isLoggedIn = () => {
  return !!getCookie('access');
};

export const getAccountType = (type = getCookie('type')): ACCOUNT_IDENTITY => {
  return type !== 'null' && !type ? type : ACCOUNT_IDENTITY.STUDENT;
};

export const isStudentAccount = (type = getCookie('type')): boolean => {
  return type === ACCOUNT_IDENTITY.STUDENT || type === 'null';
};

export const isInstructorAccount = (type = getCookie('type')): boolean => {
  return type === ACCOUNT_IDENTITY.INSTRUCTOR;
};
